import { render, staticRenderFns } from "./StaffScreen.vue?vue&type=template&id=0b62ce8d&"
import script from "./StaffScreen.vue?vue&type=script&lang=js&"
export * from "./StaffScreen.vue?vue&type=script&lang=js&"
import style0 from "./StaffScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports